import { createFileRoute, redirect } from '@tanstack/react-router';
import { useDailyKnowledgeQuestions } from '@/queries/quizlets';
import { QuizSession } from '@/components/QuizSession';
import { CircularLoader } from '@/components/CircularLoader';
import { useNavigate } from '@tanstack/react-router';
import styles from './daily-knowledge.module.scss';

export const Route = createFileRoute('/daily-knowledge')({
  component: DailyKnowledge,
  beforeLoad: ({ context }) => {
    const { user, authLoading } = context as { user: any; authLoading: boolean };
    if (authLoading) return;
    if (!user) {
      throw redirect({ to: '/' });
    }
  },
});

function DailyKnowledge() {
  const navigate = useNavigate();
  const { data, isLoading, error } = useDailyKnowledgeQuestions();

  if (isLoading) {
    return (
      <div className={styles.dailyKnowledge__loadingContainer}>
        <CircularLoader />
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.dailyKnowledge__errorContainer}>
        <p className={styles.dailyKnowledge__errorText}>
          Error loading daily knowledge: {error.message}
        </p>
      </div>
    );
  }

  if (!data || data.questions.length === 0) {
    return (
      <div className={styles.dailyKnowledge__emptyContainer}>
        <h2 className={styles.dailyKnowledge__emptyTitle}>No Daily Knowledge Questions</h2>
        <p className={styles.dailyKnowledge__emptyText}>You haven't marked any decks for daily review yet.</p>
        <p className={styles.dailyKnowledge__emptyText}>
          Go to{' '}
          <button
            onClick={() => navigate({ to: '/quizlets' })}
            className={styles.dailyKnowledge__emptyLink}
          >
            My Decks
          </button>{' '}
          and click the star (⭐) on any deck to add it to your daily review.
        </p>
      </div>
    );
  }

  const handleComplete = (score: number, correct: number, total: number) => {
    console.log('Daily Knowledge completed:', { score, correct, total });
    // You could save this to a session history here if desired
  };

  return (
    <QuizSession
      questions={data.questions}
      title="Daily Knowledge Review"
      isDailyKnowledge={true}
      onComplete={handleComplete}
    />
  );
}
